import { render, staticRenderFns } from "./PrivacyContent.vue?vue&type=template&id=bc7f098e&scoped=true"
import script from "./PrivacyContent.vue?vue&type=script&lang=js"
export * from "./PrivacyContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7f098e",
  null
  
)

export default component.exports